import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { CaseHistoryDescriptor } from './model/case.history';

@Injectable()
export class CaseHistoryService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'CaseHistoryManagement',
      authService,
      config.CAMSConfig
    );
  }

  public create(caseHistory: CaseHistoryDescriptor): Promise<CaseHistoryDescriptor> {
    return super.post<CaseHistoryDescriptor>(
      new CaseHistoryDescriptor({
        id: undefined,
        href: undefined,
        body: caseHistory.body,
        caseId: caseHistory.caseId,
        caseState: caseHistory.caseState,
        createdBy: caseHistory.createdBy,
        createdOn: new Date(),
        isPublic: caseHistory.isPublic,
        modified: caseHistory.modified,
        deleted: caseHistory.deleted
      }));
  }

  public getCaseHistories(view?: View): Promise<List<CaseHistoryDescriptor>> {
    return super.get<List<CaseHistoryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getById(id: string): Promise<CaseHistoryDescriptor> {
    return super.get<CaseHistoryDescriptor>(id);
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/case.history/case.history.service.ts